// The backend binds the redirect to the registered client and one-use flow.
// Keep an independent browser boundary: HTTPS ChatGPT or an RFC 8252 loopback (127.0.0.1, ::1, localhost).
export function isMcpAuthorizationReturnUrl(value) {
  if (typeof value !== 'string') return false;
  try {
    const target = new URL(value);
    if (target.username || target.password || target.hash) return false;
    const web = target.origin === 'https://chatgpt.com' &&
      (target.pathname === '/connector_platform_oauth_redirect' || /^\/connector\/oauth\/[A-Za-z0-9_-]{1,200}$/.test(target.pathname));
    const native = /^http:\/\/(?:127\.0\.0\.1|\[::1\]|localhost)(?::[1-9]\d{0,4})?\/callback(?:\/[A-Za-z0-9_-]{1,200})?$/.test(value.split('?')[0]);
    if (!web && !native) return false;
    const allowed = new Set(['code', 'state', 'iss', 'error', 'error_description']);
    for (const key of target.searchParams.keys()) {
      if (!allowed.has(key) || target.searchParams.getAll(key).length !== 1) return false;
    }
    return true;
  } catch {
    return false;
  }
}
